import request from '@/utils/request'
const BssApi = {
  verifySigned: () => {
    return request({
      url: '/signed/verifySigned',
      method: 'get'
    })
  },
  immediateSigned: () => {
    return request({
      url: '/signed/immediateSigned',
      method: 'get'
    })
  }
}

export default BssApi
